<template>
  <div>
    <GoBackButton class="text-left" />
    <div class="row">
      <div class="text-left col-12 col-lg-9">
        <UserData
          :user="user"
        />

        <!-- Candidate -->
        <div v-if="user && user.cv">
          <Educations
            v-if="user && user.cv && user.cv.educations"
            :educations="user.cv.educations"
          />
          <Experience
            v-if="user && user.cv && user.cv.experience"
            :experience="user.cv.experience"
          />
          <Languages
            v-if="user && user.cv && user.cv.languages"
            :languages="user.cv.languages"
          />
          <TextCv
            v-if="user && user.cv && user.cv.text_cv"
            :text-cv="user.cv.text_cv"
          />
          <Employment
            v-if="user && user.cv && user.cv.levels"
            :levels="user.cv.levels"
            :experience-time="user.cv.experienceTime"
            :categories="user.cv.categories"
            :industries="user.cv.industries"
            :contracts="user.cv.contracts"
          />
        </div>

        <!-- Company -->
        <div v-if="user && user.company">
          <CompanyControlCard :company="user" />
        </div>
      </div>
      <div class="col-12 col-lg-3 pl-lg-0">
        <Advertisement v-if="mainCardsSize >= 2" />
        <FindCourses
          v-if="mainCardsSize >= 4"
          class="text-left"
        />
        <Internships v-if="mainCardsSize >= 7" />
        <PartnerServices v-if="mainCardsSize === 3 || mainCardsSize >= 8" />
      </div>
    </div>
  </div>
</template>

<script>
import GoBackButton from '@/components/jobs/shared/GoBackButton';
import Educations from '@/components/jobs/CV/Educations';
import Experience from '@/components/jobs/CV/Experience';
import Languages from '@/components/jobs/CV/Languages';
import TextCv from '@/components/jobs/CV/TextCv';
import Employment from '@/components/jobs/CV/Employment';
import UserData from '@/components/jobs/CV/UserData';
import CompanyControlCard from '@/components/jobs/admin/CompanyControlCard';

import Advertisement from '@/components/jobs/infoSidebar/Advertisement.vue';
import PartnerServices from '@/components/jobs/infoSidebar/PartnerServices.vue';
import Internships from '@/components/jobs/infoSidebar/Internships.vue';
import FindCourses from '@/components/jobs/infoSidebar/FindCourses.vue';

export default {
  components: {
    GoBackButton,
    Educations,
    Experience,
    Languages,
    TextCv,
    Employment,
    UserData,
    CompanyControlCard,

    Advertisement,
    PartnerServices,
    Internships,
    FindCourses
  },
  data() {
    return {
      userId: null,
      user: null,
      openFullscreenModal: false,
      avatarUrl: ""
    }
  },
  computed: {
    mainCardsSize() {
      let count = 0;
      if(this.user) {
        count += 2;
        if(this.user.cv) {
          this.user.cv.levels && (count += 2);
          this.user.cv.educations && ( count += 1);
          this.user.cv.languages && ( count += 1);
          this.user.cv.skills && ( count += 1);
          this.user.cv.text_cv && ( count += 1);
        } else if(this.user.company) {
          count += 2; // company info
        }
      }  else {
        return 0;
      }
      return count;
    }
  },
  mounted() {
    this.userId = this.$route.params.id;
    this.getUser();
  },
  methods: {
    getUser() {
      this.axios.get('/users/' + this.userId)
        .then( response => {
          this.user = response.data;
        })
        .catch();
    }
  }
}
</script>
